import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    height = "height",
    backgroundColor = "backgroundColor",
}

interface Props extends WidgetProps {
    fields: {
        [fields.height]: string;
        [fields.backgroundColor]: string;
    };
}

const Spacer: FC<Props> = ({ fields: { height, backgroundColor } }) => {
    const spacerStyles = css`
        width: 100%;
        height: ${height}px;
        background-color: ${backgroundColor};
    `;

    return <StyledWrapper css={spacerStyles} />;
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        group: "Basic",
        displayName: "Spacer",
        icon: "puzzle-piece",
        fieldDefinitions: [
            {
                name: fields.height,
                displayName: "Spacer Height",
                editorTemplate: "IntegerField",
                defaultValue: 20,
                fieldType: "General",
            },
            {
                name: fields.backgroundColor,
                displayName: "Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "white",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
